import React from "react";
import { Link, useLocation } from "react-router-dom";

import "Assets/css/mntn.css";
import UseLangLstQuery from "Apis/LangTxtInqApi";

const CommMntnUi = () => {
    const location = useLocation();
    const mntnData = location.state?.mntnData;
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    
    console.log("mntnData:", mntnData);

    return(
        <>
        <div className="mntnWrap">
            <img src={process.env.PUBLIC_URL + "/images/common/mntnIcon.png"} alt="" />
            <h1>{langData && langData.COMM_MAIN_MNTN_MAIN_TITL_00}</h1>
            {/* 지금은 점검 중 입니다. */}
              <p>{langData&&langData.COMM_MAIN_MNTN_MAIN_LBL_00}<br />{langData&&langData.COMM_MAIN_ERROR_MAIN_LBL_00}</p>
            {/* 이용에 불편을 드려 죄송합니다. */}
            <div className="mntndtail">
               <p><span>{langData && langData.COMM_MAIN_MNTN_CAUS_LBL_00}</span> {mntnData && mntnData[0]?.mntnMsg}</p>
                <p className="mntnTime"><span>{langData && langData.COMM_MAIN_MNTN_TIME_LBL_00}</span> {mntnData && mntnData[0]?.mntnStrtDtime} ~ {mntnData && mntnData[0]?.mntnStopDtime}</p>
            </div>
            <p className="mntnComment">{langData && langData.COMM_MAIN_MNTN_GUIDE_CTXT_00}</p>
            <Link to={"/"}>
                {langData && langData.COMM_MAIN_MNTN_BACK_BTN_00}
            </Link>
        </div>
        </>
    )
}

export default CommMntnUi;